import Theme from 'utils/theme';

/** Virtual tab for incomplete applications (not a real workflow step). */
export const DRAFT_STEP = {
  id: 'DRAFT_INCOMPLETE',
  name: 'Draft',
  type: 'DRAFT',
};

export const stepTypeValue = {
  DRAFT: 'Draft',
  REGISTRATION: 'Apply',
  KEEP_IN_VIEW: 'Keep In View',
  IN_REVIEW: 'In Review',
  SHORTLISTED: 'Shortlisted',
  CONDITIONAL_OFFER: 'Conditional Offer',
  ACCEPTED: 'Accepted',
  DECLINED: 'Declined',
  INVITATION: 'Invitation',
  FOLLOW_UP: 'Follow Up',
  RECOMMENDED_ONE: 'Recommended One',
  RECOMMENDED_TWO: 'Recommended Two',
  RECOMMENDED_THREE: 'Recommended Three',
};

export const stepTypeColor = {
  DRAFT: Theme.DraftStep,
  REGISTRATION: Theme.RegistrationStep,
  KEEP_IN_VIEW: Theme.KeepInViewStep,
  IN_REVIEW: Theme.InReviewStep,
  SHORTLISTED: Theme.ShortlistedStep,
  CONDITIONAL_OFFER: Theme.ConditionalOfferStep,
  ACCEPTED: Theme.AcceptedStep,
  DECLINED: Theme.DeclinedStep,
  INVITATION: Theme.InvitationStep,
  FOLLOW_UP: Theme.FollowUpStep,
  RECOMMENDED_ONE: Theme.RecommendedOneStep,
  RECOMMENDED_TWO: Theme.RecommendedTwoStep,
  RECOMMENDED_THREE: Theme.RecommendedThreeStep,
};

export const stepTypeIcon = {
  DRAFT: 'saf-edit',
  REGISTRATION: 'saf-group',
  KEEP_IN_VIEW: 'saf-eye-1',
  IN_REVIEW: 'saf-star',
  SHORTLISTED: 'saf-laptop',
  CONDITIONAL_OFFER: 'saf-circle',
  ACCEPTED: 'saf-ok-circle',
  DECLINED: 'saf-block',
  INVITATION: 'saf-mail',
  FOLLOW_UP: 'saf-follow-up',
  RECOMMENDED_ONE: 'saf-recommended-1',
  RECOMMENDED_TWO: 'saf-recommended-2',
  RECOMMENDED_THREE: 'saf-recommended-3',
};

export const StepTypes = Object.keys(stepTypeValue)
  .filter((k) => k !== 'DRAFT')
  .sort()
  .map((k) => ({ label: stepTypeValue[k], value: k }));

export const StepsWithEditablePayment = ['REGISTRATION'];
export const StepsWithPayment = ['REGISTRATION', 'CONDITIONAL_OFFER'];
export const StepsWithFixedPayment = ['CONDITIONAL_OFFER'];
export const StepsWithEmail = [
  'REGISTRATION',
  'CONDITIONAL_OFFER',
  'ACCEPTED',
  'DECLINED',
  'SHORTLISTED',
  'INVITATION',
  'FOLLOW_UP',
  'RECOMMENDED_ONE',
  'RECOMMENDED_TWO',
  'RECOMMENDED_THREE',
];

export const StepsWithDoc = ['ACCEPTED'];
export const StepsWithNotify = [
  'ACCEPTED',
  'DECLINED',
  'CONDITIONAL_OFFER',
  'SHORTLISTED',
  'INVITATION',
  'FOLLOW_UP',
  'RECOMMENDED_ONE',
  'RECOMMENDED_TWO',
  'RECOMMENDED_THREE',
];
export const StepsWithSMS = [
  'REGISTRATION',
  'CONDITIONAL_OFFER',
  'ACCEPTED',
  'DECLINED',
  'SHORTLISTED',
  'INVITATION',
  'FOLLOW_UP',
  'RECOMMENDED_ONE',
  'RECOMMENDED_TWO',
  'RECOMMENDED_THREE',
];
export const stepsWithDuplicate = ['IN_REVIEW'];
export const StepsWithAutoProcess = ['REGISTRATION', 'IN_REVIEW'];

/**
 * Resolves workflow step auto-notify (API / UI: autoNotify, auto_notify).
 * Omitted or true: server sends email/PDF on stage move — do not POST /candidates/notify.
 */
export function readWorkflowStepAutoNotify(step) {
  if (step == null) {
    return undefined;
  }
  if (typeof step.autoNotify === 'boolean') {
    return step.autoNotify;
  }
  if (typeof step.auto_notify === 'boolean') {
    return step.auto_notify;
  }
  return undefined;
}

/**
 * True when the target step uses manual delivery: only then show "Send notification"
 * and allow POST /candidates/notify after PATCH. When autoNotify is not false, the
 * server handles delivery (default for new ACCEPTED steps).
 */
export function shouldOfferManualNotifyForStep(step) {
  if (!step || !StepsWithNotify.includes(step.type)) {
    return false;
  }
  return readWorkflowStepAutoNotify(step) === false;
}
